import React from "react";
import { BucketList } from "../components/buckets/BucketList.cmp";
import axios from "axios";

const DashboardPage = ({ user, onLogout }) => {
  const handleLogout = () => {
    onLogout();
  };
  // Removed unnecessary auth refresh on mount

  return (
    <div style={{ height: "100%", overflow: "hidden" }}>
      <BucketList user={user} handleLogout={handleLogout} />
    </div>
  );
};

export default DashboardPage;
